import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useInventorySystemProfile } from '../../hooks/useInventorySystemProfile'
import { updateInventorySystemProfile } from '../../services/api/updateInventorySystemProfile'
import { EditEntityPage } from '../EditEntityPage/EditEntityPage'
import { buildInventorySystemProfileEditRows } from './helpers/buildInventorySystemProfileEditRows'

export function InventorySystemProfileEditPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()
  const { profile, isLoading, error } = useInventorySystemProfile(id ?? '')

  const rows = profile ? buildInventorySystemProfileEditRows(profile) : []

  async function handleSubmit(body: Record<string, unknown>) {
    await updateInventorySystemProfile(await getToken(), id ?? '', {
      ...body,
      tenantGroupId: profile ? Number(profile.tenantGroupId) : undefined,
    })
    navigate(`/inventory-system-profiles/${id}`)
  }

  return (
    <EditEntityPage
      title={profile ? `Edit Inventory System Profile - ${profile.code}` : 'Edit Inventory System Profile'}
      backTo={`/inventory-system-profiles/${id}`}
      loadingLabel="inventory system profile"
      rows={rows}
      isLoading={isLoading}
      loadError={error}
      onSubmit={handleSubmit}
    />
  )
}
